import type { Map } from '@/types';

const getEnvironmentName = () => {
  const hosts = {
    [import.meta.env.VITE_APP_LOCAL_HOSTNAME]: 'local',
    [import.meta.env.VITE_APP_DEV_HOSTNAME]: 'dev',
    [import.meta.env.VITE_APP_PRE_HOSTNAME]: 'pre',
    [import.meta.env.VITE_APP_PROD_HOSTNAME]: 'prod'
  } as Map<string>;
  return hosts[window.location.hostname] || 'prod';
};

const env = getEnvironmentName();

const appBase = {
  local: `https://${import.meta.env.VITE_APP_LOCAL_HOSTNAME}`,
  dev: '',
  pre: '',
  prod: ''
} as Map<string>;

const apiBase = {
  local: 'http://localhost:8080/api/v1',
  dev: '/api/v1',
  pre: '/api/v1',
  prod: '/api/v1'
} as Map<string>;

const appInsights = {
  prod: import.meta.env.VITE_APP_APP_INSIGHTS_PROD
} as Map<string>;

export default {
  VITE_APP_BASE: `${appBase[env] || appBase.prod}/`,
  VITE_API_BASE: `${apiBase[env] || apiBase.prod}/`,
  VITE_APP_ENV: env,
  VITE_APP_INSIGHTS: `${appInsights[env] || ''}`
};
